'use client';

import { __assign, __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useRef, useState, useImperativeHandle, useEffect } from 'react';
import I11lPhoneNumberInput from '../../I11lPhoneNumberInput/index.js';
import Input from '../../Input/index.js';
import { ELanguage } from '../../Utils/constants.js';
import { changePhoneNumber, changeJobTitle } from '../service.js';
import { User, AvatarUser, UserInfo as UserInfo$2, Info, ErrorMsg } from '../Styled.css.js';
import DefaultAvatar from '../../Images/DefaultAvatar/index.js';
import { checkIfEmailInString } from '../../Utils/helpers.js';
import { noSpecialCharsForJobTitle } from '../../UploadResumeModal/constants.js';

var UserInfo = function (_a, ref) {
    var _b, _c, _d, _e, _f;
    var lang = _a.lang, baseUrl = _a.baseUrl, accessToken = _a.accessToken, userInfo = _a.userInfo, handleChange = _a.handleChange, t = _a.t, applyError = _a.applyError;
    var i11lPhoneNumberRef = useRef(null);
    var _g = useState((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.cellphone) !== null && _b !== void 0 ? _b : ''), phone = _g[0], setPhone = _g[1];
    var _h = useState((_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobtitle) !== null && _c !== void 0 ? _c : ''), jobTitle = _h[0], setJobTitle = _h[1];
    var _j = useState({
        phone: '',
        jobTitle: ''
    }), errMes = _j[0], setErrMes = _j[1];
    function validateI11lPhoneNumber() {
        var _a;
        var error = (_a = i11lPhoneNumberRef.current) === null || _a === void 0 ? void 0 : _a.validate();
        return !!error;
    }
    var validateJobTitle = function (value) {
        var parsedJobTitle = parseInt(value);
        /**
         * VNW-24427 [Web] HTML encode and decode job title
         * Accept all special characters
         *
         * @author PhongGP
         * @since Aug 07, 2023
         */
        var isNoValue = !value || (value && !value.trim());
        var isNoValid = checkIfEmailInString(value) || (typeof parsedJobTitle === 'number' && !isNaN(parsedJobTitle));
        var errorJobTitle = '';
        if (isNoValue) {
            errorJobTitle = t('Vui lòng nhập thông tin.');
            setErrMes(__assign(__assign({}, errMes), { jobTitle: errorJobTitle }));
            return !!errorJobTitle;
        }
        if (isNoValid) {
            errorJobTitle = t('Vui lòng không nhập số điện thoại hoặc email.');
            setErrMes(__assign(__assign({}, errMes), { jobTitle: errorJobTitle }));
            return !!errorJobTitle;
        }
        errorJobTitle = noSpecialCharsForJobTitle.test(value) ? t('Vui lòng không nhập kí tự đặc biệt.') : '';
        setErrMes(__assign(__assign({}, errMes), { jobTitle: errorJobTitle }));
        return !!errorJobTitle;
    };
    useImperativeHandle(ref, function () { return ({
        validateI11lPhoneNumber: validateI11lPhoneNumber,
        validateJobTitle: validateJobTitle
    }); }, []);
    var handleChangePhoneNumber = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error, respone, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    error = (_a = i11lPhoneNumberRef.current) === null || _a === void 0 ? void 0 : _a.validate();
                    if (phone === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.cellphone))
                        return [2 /*return*/];
                    if (error)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, changePhoneNumber({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            value: phone !== null && phone !== void 0 ? phone : ''
                        })];
                case 2:
                    respone = _b.sent();
                    if (respone && respone.data) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeJobTile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isNotValid, respone, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isNotValid = validateJobTitle(jobTitle);
                    if (jobTitle === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobtitle) || isNotValid)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, changeJobTitle({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            value: jobTitle !== null && jobTitle !== void 0 ? jobTitle : ''
                        })];
                case 2:
                    respone = _a.sent();
                    if (respone && respone.data) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        if ((applyError === null || applyError === void 0 ? void 0 : applyError.isPhoneError) && !phone) {
            (_a = i11lPhoneNumberRef.current) === null || _a === void 0 ? void 0 : _a.validate();
        }
        if ((applyError === null || applyError === void 0 ? void 0 : applyError.isJobtitleError) && !jobTitle) {
            validateJobTitle(jobTitle !== null && jobTitle !== void 0 ? jobTitle : '');
        }
    }, [applyError]);
    return (React__default.createElement(User, null,
        React__default.createElement(AvatarUser, { className: 'body__avatar' }, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) ? (React__default.createElement("img", { src: (_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.profilePicture) !== null && _d !== void 0 ? _d : '', alt: 'avatar user' })) : (React__default.createElement(DefaultAvatar, { size: 88 }))),
        React__default.createElement(UserInfo$2, { className: 'body__user' },
            React__default.createElement(Info.Name, null, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstname) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastname)
                ? "".concat((_e = userInfo.firstname) !== null && _e !== void 0 ? _e : '', " ").concat((_f = userInfo.lastname) !== null && _f !== void 0 ? _f : '')
                : ''),
            React__default.createElement(Info.Common, { onBlur: handleChangeJobTile },
                React__default.createElement(Input, { placeholder: t('Nhập chức danh' ), className: 'custom_input', onChange: function (value) {
                        setJobTitle(value);
                        setErrMes(__assign(__assign({}, errMes), { jobTitle: '' }));
                        handleChange && handleChange(value, 'jobTitle');
                    }, hasError: !!errMes.jobTitle, value: jobTitle }),
                (errMes === null || errMes === void 0 ? void 0 : errMes.jobTitle) ? React__default.createElement(ErrorMsg, null, errMes.jobTitle) : ''),
            React__default.createElement(Info.Common, { onBlur: handleChangePhoneNumber },
                React__default.createElement(I11lPhoneNumberInput, { placeholder: t('Nhập số điện thoại' ), value: phone, onChange: function (value) {
                        setPhone(value);
                        setErrMes(__assign(__assign({}, errMes), { phone: '' }));
                        handleChange && handleChange(value, 'phone');
                    }, language: lang, urlMeta: "".concat(baseUrl, "/meta/v1.0/international-phone-number"), dropdownHeight: '200px', hiddenDefaultError: false, ref: i11lPhoneNumberRef, floatingConfig: {
                        position: 'fixed',
                        enablePortal: true,
                        useWindowAsFlippingContainer: true
                    } })))));
};
var UserInfo$1 = React__default.forwardRef(UserInfo);

export { UserInfo, UserInfo$1 as default };
//# sourceMappingURL=UserInfo.js.map
